<template>
  <div v-if="visible" class="loader-overlay">
    <div class="loader" :style="loaderStyle"></div>
    <p class="mt-3 text-gray-700 text-center font-semibold">{{ loaderText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "50px",
    },
    color: {
      type: String,
      default: "#3498db",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    loaderText: {
      type: String,
      default: "Loading..."
    }
  },
  computed: {
    loaderStyle() {
      return {
        width: this.size,
        height: this.size,
        borderColor: `${this.color} transparent transparent transparent`,
      };
    },
  },
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 5px solid #3498db;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
